"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppRoutes = void 0;
var AppRoutes;
(function (AppRoutes) {
    AppRoutes["CreateInstantOrder"] = "/instant-loyalty/create";
    AppRoutes["MyCart"] = "/my-cart";
    AppRoutes["ShopHome"] = "/shop";
})(AppRoutes || (exports.AppRoutes = AppRoutes = {}));
